import Vue from 'vue';
// element
import {
    DropdownMenu,
    DropdownItem,
    Icon,
    Button,
    Toast,
    Field,
    Form,
    Tabs,
    Tab,
    List,
    Cell,
    CellGroup,
    PullRefresh,
    Picker,
    Popup,
    Uploader,
    Col,
    Row,
    Search,
    Overlay,
    ImagePreview,
    ActionSheet,
    RadioGroup,
    DatetimePicker,
    Radio,
    Empty,
    Dialog,
    Area,
    Checkbox,
    CheckboxGroup,
    TreeSelect,
    Stepper,
    NumberKeyboard,
    Calendar,
    Sticky,
    Loading,
    NavBar,
    Step, Steps  
} from 'vant';
import { Image as VanImage } from 'vant';
import App from './App.vue';
import router from './router';
import 'lib-flexible';
import 'vant/lib/icon/local.css';
import '@/style/common.scss';
import store from './store'
import './icons'
// 组件按需引入 https://youzan.github.io/vant/#/zh-CN/
Vue.use(Button);
Vue.use(Toast);
Vue.use(Field);
Vue.use(Form);
Vue.use(Tabs);
Vue.use(Tab);
Vue.use(List);
Vue.use(Cell);
Vue.use(CellGroup);
Vue.use(PullRefresh);
Vue.use(DropdownMenu);
Vue.use(DropdownItem);
Vue.use(Icon);
Vue.use(Row);
Vue.use(Empty);
Vue.use(Col);
Vue.use(Picker);
Vue.use(Overlay);
Vue.use(Popup);
Vue.use(Uploader);
Vue.use(Search);
Vue.use(RadioGroup);
Vue.use(Radio);
Vue.use(ImagePreview);
Vue.use(VanImage);
Vue.use(DatetimePicker);
Vue.use(ActionSheet);
Vue.use(Dialog);
Vue.use(Area);
Vue.use(Checkbox);
Vue.use(CheckboxGroup);
Vue.use(TreeSelect);
Vue.use(Stepper);
Vue.use(NumberKeyboard);
Vue.use(Calendar);
Vue.use(Sticky);
Vue.use(Loading);
Vue.use(NavBar);
Vue.use(Step);
Vue.use(Steps);
Vue.config.productionTip = false;
new Vue({
    router,
    store,
    render: (h) => h(App),
}).$mount('#app');
